export class APC {
    constructor(points = [], attribs) {
        this.points = points;
        this.attribs = attribs;
    }
    *[Symbol.iterator]() {
        yield* this.points;
    }
}
